import gql from "graphql-tag";

export default gql`
  mutation LazadaAssignAdminShipment($shipmentID: ID!, $admin_name: String) {
    shipmentsUpdate(_id: $shipmentID, admin: $admin_name) {
      _id
    }
  }
`;
